
export const quotes = [
  { quote: '"Dream Big!"' },
  { quote: '"A rough sea never built a skilled sailor."' },
  { quote: '"You can not stop the waves, but you can learn to surf."' },
  { quote: '"Today is a good day to have a good day."' },
  { quote: '"Build a dream and the dream will build you." - Robert H. Schuller' },
  { quote: '"Life begins at the end of your comfort zone." - Neale Donald Walsch' },
  { quote: '"You are never too old to set another goal or to dream a new dream." - Les Brown' },
  { quote: '"Dwell on the beauty of life. Watch the stars, and see yourself running with them." - Marcus Aurelius' },
  { quote: '"Do what you love, not what you think you are supposed to do." - Unknown' },
  { quote: '"Our dreams can come true if we have the courage to pursue them." - Walt Disney' },
  { quote: '"This is your life. Do what you love, and do it often." - Holstee Manifesto' },
  { quote: '"You never know how strong you are, until being strong is your only choice." - Bob Marley' },
  { quote: '"Be focused. Be determined. Be hopeful. Be empowered." - Michelle Obama' },
  { quote: '"It’s not what you look at that matters, it’s what you see." - Henry David Thoreau' },
  { quote: '"All things are difficult before they are easy." - Thomas Fuller' },
  { quote: '"All our dreams can come true if we have the courage to pursue them." - Walt Disney' },
  { quote: '"It is kind of fun to do the impossible."'
  }]



// WEBPACK FOOTER //
// ./src/home/MotivationalQuotesList.js